// Tells the lazy Menu whether the `panel` loading fallback was on screen when it mounted. The
// fallback slides and fades the panel in itself, so the Menu must take over already open: animating
// in from closed would make the panel vanish and re-appear. With no fallback (chunk already cached)
// the Menu animates in itself. Lives in the main bundle, in utils/ rather than containers/ so LoadingFallback can import it, and imports nothing.
let panelFallbackShown = false;

export function markPanelFallbackShown() {
  panelFallbackShown = true;
}

export function wasPanelFallbackShown() {
  return panelFallbackShown;
}

export function clearPanelFallbackShown() {
  panelFallbackShown = false;
}
